
import React, { useEffect, useRef, useState } from "react";
import Card from "../Card"
import { HiOutlinePhotograph } from "react-icons/hi";
import { RiDeleteBin2Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import GalleryLogo from "../../assest/gallery.png"
import {

    IconChevronsLeft,

} from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

import { addImageData, createGalleryAlbum, deleteAlbumData, deleteImageData, getGalleryAlbumData } from "../../controllers/galleryManagement.controller";
import toast from "react-hot-toast";
import Button from "../../Components/Button";


const GalleryManagement = () => {



    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [image, setImage] = useState(null);
    const navigate = useNavigate();
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedRowId, setSelectedRowId] = useState(null);

    const [data, setData] = useState([]);
    const [selectedAlbumId, setSelectedAlbumId] = useState(null)


    const [uploadedImages, setUploadedImages] = useState([]);

    const add_album_name_ref = useRef()
    const add_album_id_ref = useRef();


    // const handleImageChange = (event) => {
    //     const file = event.target.files[0];
    //     if (file) {
    //         setImage(URL.createObjectURL(file));
    //         setSelectedFile(file)
    //     }
    // };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        handleFileSelected(file);
    };


    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        handleFileSelected(file);
    };


    const handleFileSelected = (file) => {
        if (file) {
            if (file.size > 1024 * 1024) {  // 1MB limit
                toast.error("File size exceeds 1MB.");
                return;
            }
            setImage(URL.createObjectURL(file));
            setSelectedFile(file);
        } else {
            setSelectedFile(null);
        }
    };


    const fetchTableData = async () => {
        const res = await getGalleryAlbumData()
        console.log('res => ', res)

        if (res.status === 200) {
            setData(res.data.data)
        }
    }

    useEffect(() => {
        fetchTableData()
    }, [])

    const createAlbum = async () => {
        try {
            const album_name = add_album_name_ref.current.value;
            toast.loading("plaese wait");
            const res = await createGalleryAlbum({ album_name })
            const message = res.data.message;
            toast.dismiss();
            if (res.status === 200) {
                toast.success(message);
                add_album_name_ref.current.value = ''
                fetchTableData()
            }
            else {
                toast.error(message);
            }

        } catch (error) {
            console.log(error);
            const message = error?.response?.data?.message || "something went wrong";
            toast.dismiss();
            toast.error(message);
        }
    }



    useEffect(() => {
        if (selectedAlbumId) setUploadedImages(data?.find((d) => d?.album_id === selectedAlbumId)?.images || [])
        else setUploadedImages([])
    }, [selectedAlbumId, data])


    const handleRemoveImage = () => {
        setImage(null);
        setSelectedFile(null);
    };

    const addImagesBtn = async () => {
        console.log('d => ', selectedAlbumId, ' => ', selectedFile)
        if (selectedAlbumId && selectedFile) {
            try {

                toast.loading("plaese wait");
                const res = await addImageData({ album_id: selectedAlbumId, file: selectedFile, })
                const message = res.data.message;
                toast.dismiss();
                if (res.status === 200) {
                    toast.success(message);

                    fetchTableData();
                    handleRemoveImage();

                }
                else {
                    toast.error(message);
                }

            } catch (error) {
                console.log(error);
                const message = error?.response?.data?.message || "something went wrong";
                toast.dismiss();
                toast.error(message);
            }
        }
    }



    const deleteImageRow = async () => {
        try {
            if (selectedRowId) {
                toast.loading("Please wait...");
                const res = await deleteImageData({ id: selectedRowId })
                const message = res.data.message;
                toast.dismiss();
                if (res.status === 200) {
                    toast.success(message);
                    fetchTableData()
                    document.getElementById("modal-delete").close()
                } else {
                    toast.error(message);
                }
            }
        } catch (error) {
            console.error(error);
            const message = error?.response?.data?.error || "Something went wrong!";
            toast.dismiss();
            toast.error(message);
        }
    }


    // const deleteAlbum = async () => {
    //     try {
    //         if (selectedAlbumId) {
    //             toast.loading("Please wait...");
    //             const res = await deleteAlbumData({ id: setSelectedAlbumId })
    //             const message = res.data.message;
    //             toast.dismiss();
    //             if (res.status === 200) {
    //                 toast.success(message);
    //                 fetchTableData()
    //                 document.getElementById("modal-delete").close()
    //             } else {
    //                 toast.error(message);
    //             }
    //         }
    //     } catch (error) {
    //         console.error(error);
    //         const message = error?.response?.data?.error || "Something went wrong!";
    //         toast.dismiss();
    //         toast.error(message);
    //     }
    // }

    const deleteAlbum = async () => {
        try {
            if (selectedAlbumId) {
                toast.loading("Please wait...");

                const res = await deleteAlbumData({ id: selectedAlbumId });
                const message = res.data.message;
                toast.dismiss();
                if (res.status === 200) {
                    toast.success(message);
                    fetchTableData();
                    setIsDeleteModalOpen(false);
                } else {
                    toast.error(message);
                }
            }
        } catch (error) {
            console.error(error);
            const message = error?.response?.data?.error || "Something went wrong!";
            toast.dismiss();
            toast.error(message);
        }
    };



    return (
        <div>
            <div className="max-w-6xl p-6 mx-auto bg-gray-100 rounded-lg shadow-md">
                <h1 className="mb-6 text-2xl font-bold text-gray-800">Gallery Management</h1>


                <div className="p-6 mb-10 bg-white rounded-lg shadow-md">
                    <h1
                        className="mb-4 text-xl font-bold text-gray-700"
                    >
                        Create Album
                    </h1>
                    <div className="mb-4">
                        <label className="block mb-2 text-gray-600">Add Album Name</label>
                    </div>
                    <div className="flex gap-4">
                        <input
                            ref={add_album_name_ref}
                            type="text"
                            className="w-[200px] px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:[#92288C]"
                        />
                        <button
                            onClick={() => { createAlbum() }}
                            className="bg-[#92288C] text-white py-2 px-4 rounded-lg hover:bg-[#92288C] focus:outline-none focus:ring-2 w-[150px] h-100 disabled:cursor-not-allowed"
                            disabled={data.length >= 8}
                        >Create Album</button>
                    </div>
                </div>


                <div className="p-6 bg-white rounded-lg shadow-md">
                    <h2 className="mb-4 text-xl font-bold text-gray-700">Albums</h2>
                    <form>
                        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">

                            {data.map((d, i) => (
                                <div
                                    key={`image-card-${i}`}
                                    className="p-4 bg-white rounded-lg shadow-md"
                                >
                                    <h1 className="min-h-[calc(2*1.5rem)] overflow-hidden text-ellipsis line-clamp-2 leading-6 text-lg font-bold text-gray-800">
                                        {d.album_name}
                                    </h1>
                                    <img
                                        src={d.images.length > 0 ? d.images[0]?.image_url : GalleryLogo}
                                        alt="GalleryLogo"
                                        className="object-cover w-full h-40 mb-4 rounded-lg"
                                    />

                                    {/* <HiOutlinePhotograph  /> */}
                                    <div className="flex items-center justify-center w-8 h-8 rounded-md">
                                        <HiOutlinePhotograph className="text-[#92288C]" />
                                    </div>

                                    <h1 className="text-lg font-bold text-gray-800">
                                        Images Count {d.images.length}

                                    </h1>

                                    <button
                                        type="button"
                                        onClick={() => {
                                            setSelectedAlbumId(d.album_id);
                                            setIsDeleteModalOpen(true);
                                        }}
                                        className="px-3 py-1 w-full text-center bg-[#A8AAAE14] text-[#A8AAAE] border border-[#A8AAAE] rounded-md hover:bg-gray-300 mt-5"
                                    >
                                        Delete Album
                                    </button>

                                    <button
                                        type="button"
                                        onClick={() => {
                                            setSelectedAlbumId(d.album_id)
                                            document.getElementById("modal-add-images").showModal();
                                        }}
                                        className="bg-[#92288C] text-white py-2 px-4 rounded-lg hover:bg-[#75006F] focus:outline-none focus:ring-2 w-full mt-5"
                                    >
                                        Add Images
                                    </button>

                                </div>
                            ))}

                        </div>
                    </form>



                    {/* {isDeleteModalOpen && (
                        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-25">
                            <div className="w-full max-w-lg p-6 mx-auto bg-white rounded-lg shadow-lg">
                                <div className="text-center">
                                    <h2 className="text-xl font-bold text-gray-900">Delete</h2>
                                    <p className="font-bold text-gray-500">
                                        Are you sure You want to delete this Album?
                                    </p>
                                    <p className="font-bold text-gray-500">{"Album Name"}</p>
                                </div>
                                <div className="flex justify-center mt-4 space-x-4">
                                    <button
                                        onClick={() => setIsDeleteModalOpen(false)}
                                        className="px-6 py-3 text-gray-600 transition bg-gray-200 rounded-lg hover:bg-gray-200 active:scale-95 hover:shadow-lg"
                                    >
                                        No
                                    </button>
                                    <button
                                        onClick={() => {
                                            
                                       
                                            deleteAlbum();
                                        }}
                                       
                                       
                                        className="rounded-lg transition active:scale-95 hover:shadow-lg px-6 py-3 bg-[#92288C] text-white"
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>
                        </div>
                    )} */}

                    {isDeleteModalOpen && (
                        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-25">
                            <div className="w-full max-w-lg p-6 mx-auto bg-white rounded-lg shadow-lg">
                                <div className="text-center">
                                    <h2 className="text-xl font-bold text-gray-900">Delete</h2>
                                    <p className="font-bold text-gray-500">
                                        Are you sure you want to delete this album?
                                    </p>
                                    <p className="font-bold text-gray-500">{data.find(d => d.album_id === selectedAlbumId)?.album_name || "Album Name"}</p>
                                </div>
                                <div className="flex justify-center mt-4 space-x-4">
                                    <button
                                        onClick={() => setIsDeleteModalOpen(false)}
                                        className="px-6 py-3 text-gray-600 transition bg-gray-200 rounded-lg hover:bg-gray-200 active:scale-95 hover:shadow-lg"
                                    >
                                        No
                                    </button>
                                    <button
                                        onClick={deleteAlbum}
                                        className="rounded-lg transition active:scale-95 hover:shadow-lg px-6 py-3 bg-[#92288C] text-white"
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}




                    <dialog
                        id="modal-add-images"
                        className="inset-0 z-50 rounded-lg modal modal-bottom xl:modal-middle w-96"
                    >
                        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-75">
                            <div className="p-6 bg-white rounded-lg shadow-lg">
                                <h1 className="mb-4 text-lg font-bold">Add Images</h1>

                                <button
                                    onClick={() => {
                                        setSelectedAlbumId(null)
                                        document.getElementById("modal-add-images").close();
                                    }}
                                    className="text-[#92288C] flex items-center gap-2"
                                >
                                    <IconChevronsLeft />
                                    Back
                                </button>

                                <div className="mb-4">
                                    <div className="mt-2 flex flex-col items-center justify-center border-dashed border-2 border-gray-300 rounded-lg h-[200px]" onDragOver={handleDragOver} onDrop={handleDrop}>
                                        {image ? (
                                            <>
                                                <img src={image}
                                                    alt="Uploaded Preview"
                                                    className="object-contain w-auto h-28" />
                                                <div className="flex gap-4">
                                                    <Button styles={'w-40'} onClick={() => addImagesBtn()}>Save</Button>
                                                    <Button styles={'w-40'} outlined onClick={handleRemoveImage}>Remove Image</Button>
                                                </div>
                                            </>
                                        ) : (
                                            <div className="text-center text-gray-500">
                                                <p>Drag and drop image here</p>
                                                <p className="text-sm text-center text-gray-400">
                        Any size of image, will automatically adjust to the frame 
                        </p>
                                                <label className="text-[#92288C] cursor-pointer">
                                                    <input
                                                        type="file"
                                                        accept=".jpg, .png, .webp"
                                                        onChange={handleImageChange}
                                                        className="hidden"
                                                    />
                                                    Browse image
                                                </label>


                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="p-6 bg-white rounded-lg shadow-md">
                                    <h2 className="mb-4 text-xl font-bold text-gray-700">Uploaded Images</h2>
                                    <div className="overflow-y-auto max-h-60"> 
                                    <table className="w-full border-collapse">
                                        <thead>
                                            <tr className="text-left text-gray-500 border-b">
                                                <th className="px-4 py-2">Preview</th>
                                                <th className="px-4 py-2">File Name</th>
                                                <th className="px-4 py-2">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {uploadedImages.map((image, index) => (
                                                <tr key={index} className="border-b">
                                                    <td className="px-4 py-2">
                                                        <img
                                                            src={image.image_url}
                                                            alt={image.image_id}
                                                            className="object-cover w-16 h-16 rounded-lg"
                                                        />
                                                    </td>
                                                    <td className="px-4 py-2">{image.image_path}</td>
                                                    <td className="px-4 py-2">

                                                        <button
                                                            onClick={() => {
                                                                setSelectedRowId(image.image_id)
                                                                document.getElementById("modal-delete").showModal();
                                                            }}
                                                            className="flex items-center px-3 py-1 bg-[#A8AAAE14] text-[#A8AAAE] border border-[#A8AAAE] rounded-md hover:bg-gray-300"
                                                        >
                                                            Delete
                                                            <RiDeleteBin2Line className="ml-2" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                            {uploadedImages.length === 0 && (
                                                <tr>
                                                    <td colSpan="3" className="py-4 text-center text-gray-500">
                                                        No images uploaded.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </dialog>

                    <dialog
                        id="modal-delete"
                        className="inset-0 z-50 rounded-lg modal modal-bottom sm:modal-middle"
                    >

                        <div className="relative z-10 w-full max-w-lg p-6 mx-auto bg-white rounded-lg shadow-lg">
                            <div className="text-center">
                                <h2 className="text-xl font-bold text-gray-900">
                                    Delete
                                </h2>
                                <p className="font-bold text-gray-500">
                                    Are you sure?
                                </p>
                            </div>


                            <div className="flex justify-center mt-4 space-x-4">
                                <button
                                    onClick={() => {
                                        setSelectedRowId(null)
                                        document.getElementById("modal-delete").close()
                                    }}
                                    className="px-6 py-3 text-gray-600 transition bg-gray-200 rounded-lg hover:bg-gray-200 active:scale-95 hover:shadow-lg"
                                >
                                    No
                                </button>
                                <button
                                    onClick={async () => {
                                        deleteImageRow();
                                    }}
                                    className="rounded-lg transition active:scale-95 hover:shadow-lg px-6 py-3 bg-[#92288C] text-white"
                                >
                                    Yes
                                </button>
                            </div>
                        </div>
                    </dialog>


                </div>



            </div>


        </div>

    )
}

export default GalleryManagement
